<template>
	<div id="cekTransaksi">
		<div class="cekTransaksi background-gray">
			<div class="container">
				<div class="row">
					<div class="col-12 p-md-0 mt-3">
						<div class="col-12 rounded background-white shadow pt-3 pb-3 mb-5 top-slider">
							<div class="col-12" v-if="transactionDetail == 'error'">
								<div class="col-12 p-0 mt-3 pl-md-3 text-center">
									<h5 class="font-bold color-mila">Mohon maaf detail transaksi Anda tidak ditemukan</h5>
									<div class="pt-1">Pastikan kode transaksi Anda sesuai dengan bukti transaksi.</div>
								</div>
								<div class="col-12 mt-3 pt-3 pb-3 rounded">
									<div class="text-center">
										<div><img class="img-fluid" src="/assets/icon/no-data-found.svg" alt=""></div>
									</div>
								</div>
							</div>
							<div v-else>
								<div v-if="transactionDetail.code != 200">
									<SkeletonDetail/>
								</div>
								<div v-else id="StatusTransaksi">
									<div class="col-12 p-0 mt-3 pl-md-3 pr-md-3">
										<div class="col-12 mt-3 color-white background-purple text-center pt-2 pb-2 rounded font-bold font-size-14 font-size-sm-11">
											Ringkasan Transaksi
										</div>
										<div class="col-12 p-0">
											<div class="col-12 p-0 pt-3 pb-3 table-responsive pl-lg-5">
												<div class="d-flex align-items-center justify-content-start">
													<div class="min-width-75 min-width-sm-70"></div>
													<div class="rounded-circle border-5 transaction-summary font-size-14" :class="[arrStatusLog.includes('0') ? 'color-purple-2 border-purple-2' : 'color-gray border-gray']">
														<div>
															<i :class="arrStatusLog.includes('0') ? 'fas fa-check' : 'fas fa-sync'"></i>
														</div>
													</div>
													<div class="horizontal-line" :class="[arrStatusLog.includes('3') || arrStatusLog.includes('2') ? 'bg-purple-2' : 'background-gray-2']"></div>
													<div class="d-flex align-items-center justify-content-start" v-if="transactionDetail.data.trx_status == 2 ">
														<div class="rounded-circle border-5 transaction-summary font-size-14 font-size-sm-11 border-gray">
															<i class="color-red fa fa-times-circle"></i>
														</div>
														<div class="horizontal-line background-gray-2"></div>
														<div class="rounded-circle border-5 transaction-summary color-gray border-gray font-size-14 font-size-sm-11">
															<i class="fas fa-sync"></i>
														</div>
														<div class="horizontal-line background-gray-2"></div>
														<div class="rounded-circle border-5 transaction-summary color-gray border-gray font-size-14 font-size-sm-11">
															<i class="fas fa-sync"></i>
														</div>
														<div class="horizontal-line background-gray-2"></div>
														<div class="rounded-circle border-5 transaction-summary color-gray border-gray font-size-14 font-size-sm-11">
															<i class="fas fa-sync"></i>
														</div>
													</div>
													<div class="d-flex align-items-center justify-content-start" v-if="transactionDetail.data.trx_status != 2 ">
														<div class="rounded-circle border-5 transaction-summary font-size-14" :class="[arrStatusLog.includes('3') ? 'color-purple-2 border-purple-2' : 'color-gray border-gray']">
															<div>
																<i :class="arrStatusLog.includes('3') ? 'fas fa-check' : 'fas fa-sync'"></i>
															</div>
														</div>
														<div class="horizontal-line" :class="[ arrStatusLog.includes('4') || arrStatusLog.includes('5') ? 'bg-purple-2' : 'background-gray-2']"></div>
														<div class="rounded-circle border-5 transaction-summary font-size-14" :class="[arrStatusLog.includes('4') ? 'color-purple-2 border-purple-2' : 'color-gray border-gray']">
															<div v-show="!arrStatusLog.includes('5')">
																<i :class="arrStatusLog.includes('4') ? 'fas fa-check' : 'fas fa-sync'"></i>
															</div>
															<div v-show="arrStatusLog.includes('5')">
																<i class="color-red fa fa-times-circle"></i>
															</div>
														</div>
														<div class="horizontal-line" :class="[ arrStatusLog.some((el) => el == 6 || el == 7) ? 'bg-purple-2' : 'background-gray-2']"></div>
														<div class="rounded-circle border-5 transaction-summary font-size-14" :class="[arrStatusLog.some((el) => el == 6 || el == 7) ? 'color-purple-2 border-purple-2' : 'color-gray border-gray']">
															<div>
																<i :class="arrStatusLog.some((el) => el == 6 || el == 7) ? 'fas fa-check' : 'fas fa-sync'"></i>
															</div>
														</div>
														<div class="horizontal-line" :class="[ arrStatusLog.includes('9') ? 'bg-purple-2' : 'horizontal-line background-gray-2']"></div>
														<div class="rounded-circle border-5 transaction-summary font-size-14" :class="[arrStatusLog.includes('9') ? 'color-purple-2 border-purple-2' : 'color-gray border-gray']">
															<div v-show="arrStatusLog.includes('9')">
																<i class="fas fa-check"></i>
															</div>
															<div v-show="!arrStatusLog.includes('9')">
																<i class="fas fa-sync"></i>
															</div>
														</div>
													</div>
												</div>
												<div class="mt-3 d-flex align-items-center justify-content-start font-size-10 font-size-sm-8">
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold">
														{{ 0 | toStatus }}
													</div>
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold">
														{{ (arrStatusLog.includes('2') ? 2 : 3) | toStatus }}
													</div>
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold">
														{{ (arrStatusLog.includes('5') ? 5 : 4) | toStatus }}
													</div>
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold" v-if="transactionDetail.data.trx_shipping_method == 1">
														{{ 6 | toStatus }}
													</div>
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold" v-if="transactionDetail.data.trx_shipping_method == 0">
														{{ 7 | toStatus }}
													</div>
													<div class="p-0 text-center min-width-193 min-width-sm-180 font-bold">
														{{ 9 | toStatus }}
													</div>
												</div>
											</div>
										</div>
										<div class="col-12 p-0 mt-3 pt-2 pb-2">
											<div class="col-12 p-0 d-md-flex align-items-center">
												<div class="col-12 p-0 col-md-8 font-size-sm-9">
													<div class="col-12 d-flex p-0">
														<div class="col-5 col-md-4 p-0 color-black">
															Kode Transaksi
														</div>
														<div class="col-7 col-md-8 p-0">
															<span class="color-black font-bold f-lato">{{transactionDetail.data.trx_code}}</span>
														</div>
													</div>
													<div class="col-12 d-flex p-0 mt-2">
														<div class="col-5 col-md-4 p-0 color-black">
															Waktu Pembelian
														</div>
														<div class="col-7 col-md-8 p-0">
															<span class="color-black font-bold f-lato">{{transactionDetail.data.trx_datetime | hariTanggalJam}}</span>
														</div>
													</div>
												</div>
												<div class="col-12 p-0 col-md-4 text-center text-md-right mt-3 mt-md-0">
													<div class="col-12 p-0">
														<button v-if="transactionDetail.data.trx_status == 0"  @click="() => { batalTransaksi() }" class="col-12 col-md-9 col-lg-7 btn btn-outline-danger font-size-sm-9 no-box-shadow"><i class="fas fa-times mr-2"></i>Batal Transaksi</button>
														<button v-if="transactionDetail.data.trx_status == 0"  @click="() => { bayarSekarang() }" class="col-12 col-md-9 col-lg-7 btn background-button-template font-size-sm-9 no-box-shadow color-white mt-md-1 mt-2"><i class="fas fa-wallet mr-2"></i>Bayar Sekarang</button>
														<button v-if="transactionDetail.data.trx_status == 6 || transactionDetail.data.trx_status == 7"  @click="konfirmasiPenerimaan(transactionDetail.data.trx_id)" class="col-9 col-lg-7 btn background-button-template font-size-sm-9 no-box-shadow color-white">Konfirmasi Penerimaan</button>
														<a :href="transactionDetail.data.download_pdf" target="_blank" class="col-9 col-lg-7 mt-2 btn background-button-template font-size-sm-9 no-box-shadow color-white"><i class="fa fa-download mr-2"></i>Unduh Bukti</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 pr-md-3 pl-md-3 pl-0 pr-0">
										<div class="col-12 mt-3 color-white background-purple text-center pt-2 pb-2 rounded font-bold font-size-14 font-size-sm-11">
											Detail Transaksi
										</div>
									</div>
									<div class="col-12 mt-3 p-0 pl-md-3 pr-md-3">
										<div class="col-12 p-0 table-responsive">
											<table class="table table-borderless table-sm font-size-11 font-size-sm-9 table-striped">
												<thead class="color-mila">
													<tr>
														<th class="min-width-150 min-width-sm-125 text-center">Item</th>
														<th class="min-width-150 min-width-sm-100 text-center">Jumlah</th>
														<th class="min-width-50 min-width-md-150 text-right">Harga (Rp)</th>
														<th class="min-width-50 min-width-md-150 text-right">Total Harga (Rp)</th>
													</tr>
												</thead>
												<tbody class="border-bottom">
													<tr class="color-black" v-for="(value, index) in transactionDetail.data.product" v-bind:key="index">
														<td>{{value.name}}</td>
														<td class="text-center f-lato">{{value.quantity}} {{value.unit}}</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{value.price_base | toNumber}}
															</div>
														</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{value.price_total | toNumber}}
															</div>
														</td>
													</tr>
												</tbody>
												<tbody class="border-bottom" v-if="transactionDetail.data.registration">
													<tr class="color-black">
														<td>{{transactionDetail.data.registration.title}}</td>
														<td class="text-center f-lato">{{transactionDetail.data.registration.quantity}}</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{transactionDetail.data.registration.price | toNumber}}
															</div>
														</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{transactionDetail.data.registration.price_total | toNumber}}
															</div>
														</td>
													</tr>
												</tbody>
												<tbody>
													<tr v-if="transactionDetail.data.trx_shipping_method == 1">
														<td>Biaya Pengiriman</td>
														<td class="text-center f-lato">{{ transactionDetail.data.trx_weight_total | toKg }}</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{transactionDetail.data.shipping_courier.trx_shipping_courier_price_base | toNumber}}
															</div>
														</td>
														<td>
															<div class="d-flex justify-content-end f-lato">
																{{transactionDetail.data.shipping_courier.trx_shipping_courier_price_total | toNumber}}
															</div>
														</td>
													</tr>
												</tbody>
												<tr v-if="transactionDetail.data.trx_price_unique > 0">
													<td colspan="3" class="font-bold text-right">Kode Unik Transaksi</td>
													<td>
														<div class="d-flex justify-content-end f-lato">
															{{transactionDetail.data.trx_price_unique | toNumber}}
														</div>
													</td>
												</tr>
												<tr>
													<td colspan="3" class="font-bold text-right">Total Pembayaran</td>
													<td>
														<div class="d-flex justify-content-end font-bold f-lato">
															{{transactionDetail.data.trx_price_grand_total | toNumber}}
														</div>
													</td>
												</tr>
											</table>
										</div>
										<div class="col-12 d-md-flex p-0 align-items-center">
											<div class="col-12 p-0 col-md-8 font-size-sm-9">
												<div class="col-12 d-flex p-0 mt-2">
													<div class="col-5 col-md-4 p-0 color-black">
														Nama Pembeli
													</div>
													<div class="col-7 col-md-8 p-0">
														<span class="color-black">{{transactionDetail.data.trx_buyer_name}}</span>
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2">
													<div class="col-5 col-md-4 p-0 color-black">
														Mobile Counter
													</div>
													<div class="col-7 col-md-8 p-0">
														<span class="color-black">{{transactionDetail.data.stockist.stockist_name}} </span>
														<span class="color-black f-lato"> - {{ transactionDetail.data.stockist.stockist_code }}</span>
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2">
													<div class="col-5 col-md-4 p-0 color-black">
														Metode Pembayaran
													</div>
													<div class="col-7 col-md-8 p-0">
														<span class="color-black">{{transactionDetail.data.trx_payment_method | paymentMethod}}</span>
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2">
													<div class="col-5 col-md-4 p-0 color-black">
														Jenis Pengambilan
													</div>
													<div class="col-7 col-md-8 p-0" v-if="transactionDetail.data.trx_shipping_method == 0 ">
														<span>{{ this.transactionDetail.data.trx_shipping_method | shipping }}</span>
														<span v-if="transactionDetail.data.trx_status == 7" class="color-black"> (diambil oleh {{transactionDetail.data.shipping_pickup.trx_shipping_pickup_taken_by}})</span>
														<span v-else class="color-black">  (ambil di Mobile Counter)</span>
													</div>
													<div class="col-7 col-md-8 p-0" v-if="transactionDetail.data.trx_shipping_method == 1 ">
														<span>{{ this.transactionDetail.data.trx_shipping_method | shipping }}</span>
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2" v-if="transactionDetail.data.trx_shipping_method == '1'">
													<div class="col-5 col-md-4 p-0">
														Alamat Pengiriman
													</div>
													<div class="col-7 col-md-8 p-0" style="text-transform:capitalize;">
														<span class="color-black">{{transactionDetail.data.shipping_courier.trx_shipping_courier_address}},<br class="d-none d-md-block"> Kec {{transactionDetail.data.shipping_courier.trx_shipping_courier_subdistrict_name}}, {{transactionDetail.data.shipping_courier.trx_shipping_courier_city_type}} {{transactionDetail.data.shipping_courier.trx_shipping_courier_city_name}}, {{transactionDetail.data.shipping_courier.trx_shipping_courier_province_name}}</span>
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2" v-if="transactionDetail.data.trx_shipping_method == '1'">
													<div class="col-5 col-md-4 p-0">
														Jasa Pengiriman
													</div>
													<div class="col-7 col-md-8 p-0">
														<span class="color-black">{{transactionDetail.data.shipping_courier.trx_shipping_courier_name.toUpperCase()}}</span> - {{transactionDetail.data.shipping_courier.trx_shipping_courier_service.toUpperCase()}}
													</div>
												</div>
												<div class="col-12 d-flex p-0 mt-2" v-if="transactionDetail.data.trx_shipping_method == '0'">
													<div class="col-5 col-md-4 p-0 color-black">
														Alamat Pengambilan
													</div>
													<div class="col-7 col-md-8 p-0" style="text-transform:capitalize;">
														<span class="color-black">
															<span v-if="transactionDetail.data.stockist.stockist_origin_address">{{transactionDetail.data.stockist.stockist_origin_address}}</span>
															<span v-if="transactionDetail.data.stockist.stockist_origin_subdistrict_name">, {{transactionDetail.data.stockist.stockist_origin_subdistrict_name}}</span>
															<span v-if="transactionDetail.data.stockist.stockist_origin_city_name">, {{transactionDetail.data.stockist.stockist_origin_city_name}}</span>
															<span v-if="transactionDetail.data.stockist.stockist_origin_province_name">, {{transactionDetail.data.stockist.stockist_origin_province_name}} </span>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 pr-md-3 pl-md-3 pl-0 pr-0">
										<div class="col-12 mt-4 color-white background-purple text-center pt-2 pb-2 rounded font-bold font-size-14 font-size-sm-11">
											Riwayat Status Transaksi
										</div>
									</div>
									<div class="col-12 mt-3 p-0 font-size-sm-9 pl-md-3">
										<div v-for="(value,index) in reverseLog" :key="index" class="col-12 p-0 mb-md-3 d-flex align-items-start align-items-md-center f-lato">
											<div class="col-3 col-md-2 p-0 pt-2 pt-md-0 m-auto" v-if="value.trx_status_code == 0 || value.trx_status_code == 9 || value.trx_status_code == 10 || value.trx_status_code == 14">
												<div :class="value.trx_status_code == transactionDetail.data.trx_status ? 'background-card' : 'background-gray-2'" class="col-12 pt-md-2 pb-md-2 rounded color-white text-center text-md-right">Customer</div>
											</div>
											<div class="col-3 col-md-2 p-0 pt-2 pt-md-0 m-auto" v-else-if="value.trx_status_code ==1 || value.trx_status_code == 2 || value.trx_status_code == 3 || value.trx_status_code== 13">
												<div :class="value.trx_status_code == transactionDetail.data.trx_status ? 'background-card' : 'background-gray-2'" class="col-12 pt-md-2 pb-md-2 rounded color-white text-center text-md-right">System</div>
											</div>
											<div class="col-3 col-md-2 p-0 pt-2 pt-md-0 m-auto" v-else-if="value.trx_status_code ==4 || value.trx_status_code == 5 || value.trx_status_code == 6 || value.trx_status_code == 7 || value.trx_status_code == 8 || value.trx_status_code == 11 || value.trx_status_code == 12 || value.trx_status_code == 15">
												<div :class="value.trx_status_code == transactionDetail.data.trx_status ? 'background-card' : 'background-gray-2'" class="col-12 pt-md-2 pb-md-2 rounded color-white text-center text-md-right">Mobile Counter</div>
											</div>
											<div class="col-9 col-md-10 p-0 pt-2 pt-md-0">
												<div class="col-12 color-gray">{{value.trx_status_datetime | hariTanggalJam}}</div>
												<div :class="value.trx_status_code == transactionDetail.data.trx_status ? 'color-mila' : 'color-gray-2'" class="col-12 font-bold">{{ value.trx_status_code | toStatus }}</div>
											</div>
										</div>
									</div>
									<v-modal class="konfirmasi" ref="KonfirmasiTransfer">
										<template v-slot:header>
											<div class="modal-header d-block">
												<h4 class="modal-title text-center font-size-sm-13">{{transactionDetail.data.trx_payment_method == 1 ? 'Konfirmasi Transfer' : 'Informasi Pembayaran'}}</h4>
											</div>
										</template>
										<div slot="body">
											<KonfirmasiTransfer :paramBayar="paramBayar" />
										</div>
										<template v-slot:footer>
											<div class="modal-footer justify-content-center">
												<button type="button" class="col col-md-2 btn btn-outline-danger text-capitalize"  @click="$refs.KonfirmasiTransfer.modalHide()" ><i class="fas fa-times mr-3"></i>{{transactionDetail.data.trx_payment_method == 1 ? 'Batal' : 'Tutup'}}</button>
												<button v-if="transactionDetail.data.trx_payment_method == 1" type="button" class="col col-md-3 btn background-button-template color-white text-capitalize" @click="konfirmasiBayar();">
													Konfirmasi<i class="fas fa-arrow-right ml-3"></i>
												</button>
											</div>
										</template>
									</v-modal>

									<VModal ref="BatalTransaksi" class="modalKonfirmasi modal-small">
										<template v-slot:header>
											<div></div>
										</template>
										<template v-slot:body>
											<div class="modal-body">
												<div class="col-12 d-md-flex mt-n3 mt-md-0">
													<div class="col-5 m-auto pt-1 pl-0 pr-md-3 pr-0">
														<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
													</div>
													<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
														<div class="font-bold font-size-sm-12">Konfirmasi Batal Transaksi</div>
														<div class="font-size-sm-11 pt-2">Apakah Anda yakin ingin membatalkan transaksi ini?</div>
													</div>
												</div>
											</div>
										</template>
										<template v-slot:footer>
											<div class="modal-footer justify-content-center justify-content-md-end">
												<button type="button" class="col-6 col-md-3 btn btn-outline-danger text-capitalize"  @click="$refs.BatalTransaksi.modalHide()" ><i class="fas fa-times mr-3"></i>Batal</button>
												<button type="button" class="col-6 col-md-4 btn background-button-template color-white text-capitalize" @click="putBatalTransaksi();"><i class="fas fa-check mr-3"></i>Saya Yakin</button>
											</div>
										</template>
									</VModal>

									<VModal ref="konfirmasiPenerimaan" class="modalKonfirmasi modal-small">
										<template v-slot:header>
											<div></div>
										</template>
										<template v-slot:body>
											<div class="modal-body">
												<div class="col-12 d-md-flex mt-n3 mt-md-0">
													<div class="col-5 m-auto pt-1 pl-0 pr-md-3 pr-0">
														<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
													</div>
													<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
														<div class="font-bold font-size-sm-12">Konfirmasi Penerimaan</div>
														<div class="font-size-sm-11 pt-2">Apakah Anda Yakin Sudah Menerima Pesanan Ini ?</div>
													</div>
												</div>
											</div>
										</template>
										<template v-slot:footer>
											<div class="modal-footer justify-content-center justify-content-md-end">
												<button type="button" class="col-6 col-md-3 btn btn-outline-danger text-capitalize"  @click="$refs.konfirmasiPenerimaan.modalHide()" >
													<i class="fa fa-times mr-1"></i>
													<span>Batal</span>
												</button>
												<button type="button" class="col-6 col-md-3 btn background-button-template color-white text-capitalize" @click="putKonfirmasiPenerimaan();">
													<i class="fa fa-check mr-1"></i>
													<span>Konfirmasi</span>
												</button>
											</div>
										</template>
									</VModal>

									<VModal ref="konfirmasiPenerimaanSukses" class="modalKonfirmasi modal-small">
										<template v-slot:header>
											<div></div>
										</template>
										<template v-slot:body>
											<div class="modal-body">
												<div class="col-12 d-md-flex">
													<div class="col-5 m-auto pt-1 pl-0">
														<img class="img-fluid" src="/assets/icon/smile-woman.svg">
													</div>
													<div class="col-12 col-md-7 color-black m-auto pt-3 pt-md-0">
														<div class="font-size-sm-11">Terima Kasih Telah Berbelanja di Milagros</div>
													</div>
												</div>
											</div>
										</template>
										<template v-slot:footer>
											<div>
											</div>
										</template>
									</VModal>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import SkeletonDetail from '@/components/Skeleton/SkeletonDetailTransaksi'
import KonfirmasiTransfer from '@/views/member/KonfirmasiTransfer';
import moment from 'moment';
import VModal from '@/components/VModal';
export default {
	name: 'StatusTransaksi',
	components: {
		VModal,
		KonfirmasiTransfer,
		SkeletonDetail
	},

	data: () => ({
		pilihan:'transaction_code',
		pilihanFilter:[{value:'trx_code' , name: 'Kode Transaksi'},{value:'stockist_code' , name:'Kode Stockist'}],
		kodeinputan:'',
		tanggalawal:"",
		tanggalakhir:"",
		currentPage:1,
		total_page:0,
		readyToLoad: true,
		detailPembayaran: false,
		KonfirmasiTransfer: false,
		msg: 'Belum ada pesanan',
		transaksi:{
			code : '',
			mobilephone : '',
		},
		dataTransaksi:{
			code:'',
			data:''
		},
		page: 1,
		status:' ',
		paramsAwal:{
			limit: 5,
			page: 1,
			sort: 'transaction_datetime',
			dir: 'DESC'
		},
		paramKonfirm:{
			transaction_id:''
		},
		paramBayar: {
			bank_name: '',
			namaRekening: '',
			nomorRekening: '',
			cabang: '',
			nominal: '',
			transfer_date: '',
			note: '',
		},
		parameter: {
			trx_id : '',
			to_bank_account_id : '',
			from_bank_name : '',
			from_bank_account_name : '',
			from_bank_account_no : '',
			from_bank_branch : '',
			transfer_value : '',
			transfer_date : '',
			note : '',
		},
		paramCancel: {
			trx_id: ''
		}
	}),
	computed:{
		...mapState('transactionMember', ['transactionDetail', 'konfirmResponse']),
		...mapGetters('auth', ['isAuth']),

		reverseLog() {
			let b = [... this.transactionDetail.data.trx_status_log]
			if(this.transactionDetail.data.trx_status == 9) {
				let arr = b.reverse();
				return arr
			} else {
				return b.reverse();
			}
		},

		arrStatusLog() {
			let b = [... this.transactionDetail.data.trx_status_log]
			let arr = []
			b.forEach( function(element) {
				arr.push(element.trx_status_code)
			});
			return arr;
		},
	},
	methods: {
		...mapActions('transactionMember', [ 'getTransaction', 'getTransactionDetail', 'konfirmation', 'cancelTransaction', 'saveConfirmResponse', 'Penerimaan']),
		...mapMutations('transactionMember', ['reset']),
		bayarSekarang() {
			this.transaksi.code = this.transactionDetail.data.trx_code
			this.transaksi.mobilephone = this.transactionDetail.data.trx_buyer_mobilephone
			
			this.getTransactionDetail({code: this.$route.params.code})
			this.$refs.KonfirmasiTransfer.modalShow()
		},

		batalTransaksi() {
			this.paramCancel.trx_id = this.transactionDetail.data.trx_id
			this.$refs.BatalTransaksi.modalShow()
		},

		konfirmasiBayar() {
			this.parameter.trx_id = this.transactionDetail.data.trx_id
			this.parameter.to_bank_account_id = this.transactionDetail.data.payment_bank.trx_payment_bank_choose_bank_account_id
			this.parameter.from_bank_name = this.paramBayar.bank_name
			this.parameter.from_bank_account_name = this.paramBayar.namaRekening
			this.parameter.from_bank_account_no = this.paramBayar.nomorRekening
			this.parameter.from_bank_branch = this.paramBayar.cabang
			this.parameter.transfer_value = this.paramBayar.nominal
			this.parameter.transfer_date = moment(this.paramBayar.transfer_date).format('YYYY-MM-DD')
			this.parameter.note = this.paramBayar.note
			this.konfirmation({param: this.parameter, status: true})
		},

		putBatalTransaksi() {
			this.cancelTransaction({trx_id : this.paramCancel.trx_id}).then( () => this.getTransactionDetail({code: this.$route.params.code}) )
			this.$refs.BatalTransaksi.modalHide()
		},
		
		putKonfirmasiPenerimaan() {
			this.Penerimaan({trx_id : this.paramKonfirm.trx_id}).then(()=> {
				this.$refs.konfirmasiPenerimaan.modalHide()
				setTimeout(() => {
					this.$refs.konfirmasiPenerimaanSukses.modalShow()
				}, 500)
				setTimeout(() => {
					this.$refs.konfirmasiPenerimaanSukses.modalHide()
				}, 2500)
			})
		},

		konfirmasiPenerimaan(val) {
			this.paramKonfirm.trx_id = val
			this.$refs.konfirmasiPenerimaan.modalShow()
		},
	},
	created(){
		this.getTransactionDetail({code: this.$route.params.code})
	},
	watch:{
		konfirmResponse() {
			if(this.konfirmResponse.code == '200') {
				this.$refs.KonfirmasiTransfer.modalHide()
			}
		},
	},
	beforeDestroy(){
		this.reset()
	}
}
</script>

<style>

</style>